import { createStore } from 'vuex'

import * as adminAchievement from '@/store/modules/admin/achievement'
import * as adminAddress from '@/store/modules/admin/address'
import * as administrativeProceedingReminder from '@/store/modules/admin/administrativeProceedingReminder'
import * as adminBank from '@/store/modules/admin/bank'
import * as adminBaseInterestRate from '@/store/modules/admin/baseInterestRate'
import * as adminBlacklist from '@/store/modules/admin/blacklist'
import * as adminBrand from '@/store/modules/admin/brand'
import * as bulutTahsilat from '@/store/modules/admin/bulutTahsilat'
import * as adminCampaign from '@/store/modules/admin/campaign'
import * as adminCampaignDetail from '@/store/modules/admin/campaignDetail'
import * as adminCategory from '@/store/modules/admin/category'
import * as adminCity from '@/store/modules/admin/city'
import * as adminComment from '@/store/modules/admin/comment'
import * as adminCompany from '@/store/modules/admin/company'
import * as adminContact from '@/store/modules/admin/contact'
import * as adminCoupon from '@/store/modules/admin/coupon'
import * as adminCrop from '@/store/modules/admin/crop'
import * as adminCropPriceIndex from '@/store/modules/admin/cropPriceIndex'
import * as adminCurrentAccountActivity from '@/store/modules/admin/currentAccountActivity'
import * as adminDashboard from '@/store/modules/admin/dashboard'
import * as adminDeliveryReminder from '@/store/modules/admin/deliveryReminder'
import * as adminDocument from '@/store/modules/admin/document'
import * as adminDocumentProcess from '@/store/modules/admin/documentProcess'
import * as downloadImportTemplate from '@/store/modules/admin/downloadImportTemplate'
import * as adminExportOrderDocuments from '@/store/modules/admin/exportOrderDocuments'
import * as adminFaq from '@/store/modules/admin/faq'
import * as adminFarmer from '@/store/modules/admin/farmer'
import * as adminFarmerDocument from '@/store/modules/admin/farmerDocument'
import * as adminFarmRunner from '@/store/modules/admin/farmRunner'
import * as adminFinancingCostRule from '@/store/modules/admin/financingCostRule'
import * as adminFinancingCostSummary from '@/store/modules/admin/financingCostSummary'
import * as adminFindeksRequest from '@/store/modules/admin/findeksRequest'
import * as adminGoal from '@/store/modules/admin/goal'
import * as adminHoliday from '@/store/modules/admin/holiday'
import * as adminInterestRate from '@/store/modules/admin/interestRate'
import * as adminJobBoard from '@/store/modules/admin/jobBoard'
import * as adminLateFeeInterest from '@/store/modules/admin/lateFeeInterest'
import * as adminMobileBanner from '@/store/modules/admin/mobileBanner'
import * as adminMobileContact from '@/store/modules/admin/mobileContact'
import * as adminOrder from '@/store/modules/admin/order'
import * as adminOrderDocument from '@/store/modules/admin/orderDocument'
import * as adminOrderItem from '@/store/modules/admin/orderItem'
import * as adminOrderNotification from '@/store/modules/admin/orderNotification'
import * as adminPayment from '@/store/modules/admin/payment'
import * as adminPaymentReminder from '@/store/modules/admin/paymentReminder'
import * as adminPermission from '@/store/modules/admin/permission'
import * as adminPhoneSurvey from '@/store/modules/admin/phoneSurvey'
import * as adminPhoneSurveyAnswer from '@/store/modules/admin/phoneSurveyAnswer'
import * as adminPost from '@/store/modules/admin/post'
import * as adminPreApprovedLimitApplication from '@/store/modules/admin/preApprovedLimitApplication'
import * as adminProduct from '@/store/modules/admin/product'
import * as adminProductMarketPrice from '@/store/modules/admin/productMarketPrice'
import * as adminProductPrice from '@/store/modules/admin/productPrice'
import * as adminPurchase from '@/store/modules/admin/purchase'
import * as adminPurchaseDetail from '@/store/modules/admin/purchaseDetail'
import * as adminPurchasePeriod from '@/store/modules/admin/purchasePeriod'
import * as adminPurchaseRequest from '@/store/modules/admin/purchaseRequest'
import * as adminRank from '@/store/modules/admin/rank'
import * as adminRegion from '@/store/modules/admin/region'
import * as adminRelatedPost from '@/store/modules/admin/relatedPost'
import * as adminReminderCall from '@/store/modules/admin/reminderCall'
import * as adminReport from '@/store/modules/admin/report'
import * as adminRetailer from '@/store/modules/admin/retailer'
import * as adminRetailerDebt from '@/store/modules/admin/retailerDebt'
import * as adminRetailerOrderPayment from '@/store/modules/admin/retailerOrderPayment'
import * as adminRetailerPayment from '@/store/modules/admin/retailerPayment'
import * as adminRetailerShortSale from '@/store/modules/admin/retailerShortSale'
import * as adminRetailerStockInput from '@/store/modules/admin/retailerStockInput'
import * as adminRetailerStockOutput from '@/store/modules/admin/retailerStockOutput'
import * as adminReward from '@/store/modules/admin/reward'
import * as adminRole from '@/store/modules/admin/role'
import * as adminSalesChannel from '@/store/modules/admin/salesChannel'
import * as adminSearch from '@/store/modules/admin/search'
import * as adminServiceError from '@/store/modules/admin/serviceError'
import * as adminSettings from '@/store/modules/admin/settings'
import * as adminSubCategory from '@/store/modules/admin/subCategory'
import * as adminSuggestedProduct from '@/store/modules/admin/suggestedProduct'
import * as adminSupplier from '@/store/modules/admin/supplier'
import * as adminSupplierContact from '@/store/modules/admin/supplierContact'
import * as supplierCurrentAccount from '@/store/modules/admin/supplierCurrentAccount'
import * as adminSupplierDriver from '@/store/modules/admin/supplierDriver'
import * as adminSupplierStatus from '@/store/modules/admin/supplierStatus'
import * as adminSupplierVehicle from '@/store/modules/admin/supplierVehicle'
import * as adminSurvey from '@/store/modules/admin/survey'
import * as adminSystemNotification from '@/store/modules/admin/systemNotification'
import * as adminTarfinProCampaign from '@/store/modules/admin/tarfinProCampaign'
import * as adminTarfinProCollateralType from '@/store/modules/admin/tarfinProCollateralType'
import * as adminTarfinProMaturityDay from '@/store/modules/admin/tarfinProMaturityDay'
import * as adminTarfinProProductPrice from '@/store/modules/admin/tarfinProProductPrice'
import * as adminTarfinProQuotation from '@/store/modules/admin/tarfinProQuotation'
import * as adminTarfinProQuotationDocument from '@/store/modules/admin/tarfinProQuotationDocument'
import * as adminTarfinProStockInterest from '@/store/modules/admin/tarfinProStockInterest'
import * as adminTmks from '@/store/modules/admin/tmks'
import * as adminUnit from '@/store/modules/admin/unit'
import * as userActivity from '@/store/modules/admin/userActivity'
import * as adminWorkflow from '@/store/modules/admin/workflow'
import * as notification from '@/store/modules/helpers/notification.js'
import * as notificationPermission from '@/store/modules/helpers/notificationPermission.js'
import * as sideMenu from '@/store/modules/helpers/sideMenu.js'
import * as publicFarmer from '@/store/modules/public/farmer.js'
import * as publicFarmerDocuments from '@/store/modules/public/farmerDocuments.js'
import * as farmerRequiredDocuments from '@/store/modules/public/farmerRequiredDocuments'
import * as farmerInvoice from '@/store/modules/public/invoice.js'
import * as publicOrder from '@/store/modules/public/order.js'
import * as publicOrderDocuments from '@/store/modules/public/orderDocuments.js'
import * as overduePaymentInformation from '@/store/modules/public/overduePaymentInformation'
import * as application from '@/store/modules/retailer/application'
import * as applicationFibaBank from '@/store/modules/retailer/applicationFibaBank'
import * as applicationForward from '@/store/modules/retailer/applicationForward'
import * as applicationRomania from '@/store/modules/retailer/applicationRomania'
import * as retailerBankAccounts from '@/store/modules/retailer/bankAccount'
import * as retailerBaseInterestRate from '@/store/modules/retailer/baseInterestRate'
import * as retailerBrand from '@/store/modules/retailer/brand'
import * as breadcrumb from '@/store/modules/retailer/breadcrumb'
import * as retailerCompany from '@/store/modules/retailer/company'
import * as retailerCrop from '@/store/modules/retailer/crop'
import * as currentAccountActivity from '@/store/modules/retailer/currentAccountActivity'
import * as retailerDashboard from '@/store/modules/retailer/dashboard'
import * as retailerFarmer from '@/store/modules/retailer/farmer'
import * as retailerFarmerDocument from '@/store/modules/retailer/farmerDocument'
import * as farmRunner from '@/store/modules/retailer/farmRunner'
import * as retailerGoal from '@/store/modules/retailer/goal'
import * as holiday from '@/store/modules/retailer/holiday'
import * as mobileContact from '@/store/modules/retailer/mobileContact'
import * as retailerNotificationDevice from '@/store/modules/retailer/notificationDevice'
import * as retailerNotifications from '@/store/modules/retailer/notifications'
import * as retailerOrder from '@/store/modules/retailer/order'
import * as retailerOrderDocument from '@/store/modules/retailer/orderDocument'
import * as retailerPrice from '@/store/modules/retailer/price'
import * as retailerProduct from '@/store/modules/retailer/product'
import * as retailerPurchase from '@/store/modules/retailer/purchase'
import * as purchaseOffer from '@/store/modules/retailer/purchaseOffer'
import * as receipt from '@/store/modules/retailer/receipt'
import * as retailerRequiredDocuments from '@/store/modules/retailer/requiredDocuments'
import * as retailer from '@/store/modules/retailer/retailer'
import * as salesChannel from '@/store/modules/retailer/salesChannel'
import * as stockInputs from '@/store/modules/retailer/stockInputs'
import * as retailerSubRetailer from '@/store/modules/retailer/subRetailer'
import * as retailerSurvey from '@/store/modules/retailer/survey'
import * as retailerTarfinProInfoText from '@/store/modules/retailer/tarfinProInfoText'
import * as retailerTarfinProProductPrice from '@/store/modules/retailer/tarfinProProductPrice'
import * as retailerTarfinProQuotation from '@/store/modules/retailer/tarfinProQuotation'
import * as retailerUnit from '@/store/modules/retailer/unit'

import * as adminApplication from './modules/admin/application'
import * as adminApproval from './modules/admin/approval'
import * as auth from './modules/admin/auth'
import * as adminBulkFarmerLimitApplications from './modules/admin/bulkFarmerLimitApplications'
import * as adminKeysfinFinancialInfo from './modules/admin/keysfinFinancialInfo'
import * as user from './modules/admin/user'
import * as retailerAuth from './modules/retailer/auth'
import * as retailerUser from './modules/retailer/user'

const debug = import.meta.env.MODE !== 'production'

export default createStore({
  modules: {
    auth,
    user,
    notification,
    notificationPermission,
    retailerAuth,
    application,
    adminApplication,
    adminProduct,
    holiday,
    adminCategory,
    adminSubCategory,
    adminRetailer,
    adminCompany,
    adminRetailerDebt,
    adminBaseInterestRate,
    adminExportOrderDocuments,
    adminInterestRate,
    adminSalesChannel,
    adminSurvey,
    adminCoupon,
    retailerSurvey,
    adminOrder,
    retailer,
    salesChannel,
    sideMenu,
    adminFarmer,
    adminFarmerDocument,
    adminMobileContact,
    adminMobileBanner,
    retailerUser,
    retailerFarmer,
    retailerOrder,
    retailerDashboard,
    adminKeysfinFinancialInfo,
    adminRetailerPayment,
    adminRetailerOrderPayment,
    adminPayment,
    adminHoliday,
    adminWorkflow,
    adminOrderNotification,
    adminBank,
    adminDashboard,
    adminComment,
    adminAddress,
    adminPurchase,
    adminPurchaseDetail,
    userActivity,
    adminRole,
    adminPermission,
    adminReport,
    adminRegion,
    adminCity,
    adminCampaign,
    adminCampaignDetail,
    adminFarmRunner,
    adminSystemNotification,
    farmRunner,
    adminOrderItem,
    adminSettings,
    adminPhoneSurvey,
    adminPhoneSurveyAnswer,
    adminRank,
    adminGoal,
    adminAchievement,
    adminReward,
    retailerGoal,
    adminCrop,
    adminCropPriceIndex,
    retailerCrop,
    retailerPurchase,
    adminDocument,
    adminDocumentProcess,
    retailerSubRetailer,
    adminPurchasePeriod,
    adminContact,
    adminSearch,
    retailerPrice,
    adminBlacklist,
    adminPaymentReminder,
    adminDeliveryReminder,
    adminProductPrice,
    adminBrand,
    mobileContact,
    retailerBrand,
    farmerInvoice,
    adminPost,
    adminJobBoard,
    adminReminderCall,
    receipt,
    adminSuggestedProduct,
    retailerNotifications,
    adminRetailerShortSale,
    adminRetailerStockInput,
    adminRetailerStockOutput,
    adminUnit,
    applicationFibaBank,
    applicationForward,
    applicationRomania,
    adminFaq,
    administrativeProceedingReminder,
    stockInputs,
    retailerProduct,
    retailerUnit,
    breadcrumb,
    currentAccountActivity,
    adminCurrentAccountActivity,
    adminProductMarketPrice,
    adminFindeksRequest,
    adminTarfinProQuotation,
    adminTarfinProQuotationDocument,
    adminTarfinProCollateralType,
    adminTarfinProMaturityDay,
    adminTarfinProCampaign,
    adminTarfinProStockInterest,
    retailerBaseInterestRate,
    adminServiceError,
    retailerCompany,
    bulutTahsilat,
    adminLateFeeInterest,
    retailerRequiredDocuments,
    farmerRequiredDocuments,
    overduePaymentInformation,
    adminTarfinProProductPrice,
    retailerTarfinProProductPrice,
    retailerTarfinProInfoText,
    adminPreApprovedLimitApplication,
    adminFinancingCostSummary,
    adminRelatedPost,
    adminFinancingCostRule,
    retailerFarmerDocument,
    retailerOrderDocument,
    retailerTarfinProQuotation,
    adminSupplier,
    adminSupplierContact,
    adminSupplierDriver,
    adminSupplierVehicle,
    adminSupplierStatus,
    supplierCurrentAccount,
    retailerBankAccounts,
    purchaseOffer,
    retailerNotificationDevice,
    adminPurchaseRequest,
    downloadImportTemplate,
    adminApproval,
    publicFarmer,
    publicFarmerDocuments,
    adminBulkFarmerLimitApplications,
    publicOrder,
    publicOrderDocuments,
    adminOrderDocument,
    adminTmks
  },
  state: {}
  //strict: debug,
  //plugins: debug ? [createLogger()] : []
})
